import React from "react";
import "./Col.css";

const Col = ({ height }) => (
  <div className={"array-bar"} style={{ height }}></div>
);

export default Col;
